import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/5rtHZUgQD2bv2iapiJEGC2/Mockup.png';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-65" data-mp="9ih0dmtnseqi">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-66" data-mp="129h37ug97cgl" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-67" data-mp="1274mfkm8f854">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-68" data-mp="xbp8yts4ze98">
          🌿 BIOMA LÍVIDO™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-5xl font-display text-[21px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-69" data-mp="3cz5w0drpe41e">
          Desinflamá tu abdomen en 30 días{' '}
          <span className="text-brand-light" data-id="element-70" data-mp="399jm7a81g94j">
            con un sistema de 3 fases para frenar el SIBO desde casa.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-71" data-mp="30i19586e29fo">
          <img src={mockupUrl} alt="Mockup del libro Protocolo Rescate SIBO con sus páginas interiores" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-72" data-mp="2qlepgmpstof8" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl" data-id="element-73" data-mp="s1rsao8pe6ua">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-74" data-mp="id03goyxw2nl">
            PROTOCOLO RESCATE SIBO™
          </p>
          <p className="-mb-4 mt-3 text-[13px] text-slate-200 sm:text-base" data-id="element-75" data-mp="1b0njrrt6g74f">
            El sistema completo, paso a paso, para bajar la hinchazón, ordenar tu
            digestión y reintroducir alimentos sin recaer.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-76" data-mp="111om149y9vw7">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-77" data-mp="x0l328wlvjqr">
              <FileTextIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-78" data-mp="3lqm1dvdxqztc" />
              300+ páginas en PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-79" data-mp="1x9uk28qzz9md">
              <ZapIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-80" data-mp="21bplrecubp0o" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45,
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-81" data-mp="2b0fy9k5iavdx">
          <ActionButton href="#pricing" showTrust data-id="element-82" data-mp="2kxc75qzbhjj0">
            🌿 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}